/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClimateMode } from './ClimateMode';
import {
    ClimateModeFromJSON,
    ClimateModeFromJSONTyped,
    ClimateModeToJSON,
    ClimateModeToJSONTyped,
} from './ClimateMode';
import type { WeekscheduleState } from './WeekscheduleState';
import {
    WeekscheduleStateFromJSON,
    WeekscheduleStateFromJSONTyped,
    WeekscheduleStateToJSON,
    WeekscheduleStateToJSONTyped,
} from './WeekscheduleState';
import type { RemoteLogging } from './RemoteLogging';
import {
    RemoteLoggingFromJSON,
    RemoteLoggingFromJSONTyped,
    RemoteLoggingToJSON,
    RemoteLoggingToJSONTyped,
} from './RemoteLogging';
import type { SharingPolicy } from './SharingPolicy';
import {
    SharingPolicyFromJSON,
    SharingPolicyFromJSONTyped,
    SharingPolicyToJSON,
    SharingPolicyToJSONTyped,
} from './SharingPolicy';
import type { PreheatSetpoint } from './PreheatSetpoint';
import {
    PreheatSetpointFromJSON,
    PreheatSetpointFromJSONTyped,
    PreheatSetpointToJSON,
    PreheatSetpointToJSONTyped,
} from './PreheatSetpoint';
import type { Legionella } from './Legionella';
import {
    LegionellaFromJSON,
    LegionellaFromJSONTyped,
    LegionellaToJSON,
    LegionellaToJSONTyped,
} from './Legionella';
import type { FilterState } from './FilterState';
import {
    FilterStateFromJSON,
    FilterStateFromJSONTyped,
    FilterStateToJSON,
    FilterStateToJSONTyped,
} from './FilterState';
import type { DhwBoost } from './DhwBoost';
import {
    DhwBoostFromJSON,
    DhwBoostFromJSONTyped,
    DhwBoostToJSON,
    DhwBoostToJSONTyped,
} from './DhwBoost';
import type { AmbientOffset } from './AmbientOffset';
import {
    AmbientOffsetFromJSON,
    AmbientOffsetFromJSONTyped,
    AmbientOffsetToJSON,
    AmbientOffsetToJSONTyped,
} from './AmbientOffset';
import type { ConfigSettings } from './ConfigSettings';
import {
    ConfigSettingsFromJSON,
    ConfigSettingsFromJSONTyped,
    ConfigSettingsToJSON,
    ConfigSettingsToJSONTyped,
} from './ConfigSettings';
import type { FlameState } from './FlameState';
import {
    FlameStateFromJSON,
    FlameStateFromJSONTyped,
    FlameStateToJSON,
    FlameStateToJSONTyped,
} from './FlameState';
import type { BoilerControlMode } from './BoilerControlMode';
import {
    BoilerControlModeFromJSON,
    BoilerControlModeFromJSONTyped,
    BoilerControlModeToJSON,
    BoilerControlModeToJSONTyped,
} from './BoilerControlMode';
import type { HeatPumpSetup } from './HeatPumpSetup';
import {
    HeatPumpSetupFromJSON,
    HeatPumpSetupFromJSONTyped,
    HeatPumpSetupToJSON,
    HeatPumpSetupToJSONTyped,
} from './HeatPumpSetup';
import type { DeviceInfo } from './DeviceInfo';
import {
    DeviceInfoFromJSON,
    DeviceInfoFromJSONTyped,
    DeviceInfoToJSON,
    DeviceInfoToJSONTyped,
} from './DeviceInfo';
import type { DhwPreferences } from './DhwPreferences';
import {
    DhwPreferencesFromJSON,
    DhwPreferencesFromJSONTyped,
    DhwPreferencesToJSON,
    DhwPreferencesToJSONTyped,
} from './DhwPreferences';
import type { Ventilation } from './Ventilation';
import {
    VentilationFromJSON,
    VentilationFromJSONTyped,
    VentilationToJSON,
    VentilationToJSONTyped,
} from './Ventilation';
import type { RoomSetpoint } from './RoomSetpoint';
import {
    RoomSetpointFromJSON,
    RoomSetpointFromJSONTyped,
    RoomSetpointToJSON,
    RoomSetpointToJSONTyped,
} from './RoomSetpoint';
import type { ErrorsInner } from './ErrorsInner';
import {
    ErrorsInnerFromJSON,
    ErrorsInnerFromJSONTyped,
    ErrorsInnerToJSON,
    ErrorsInnerToJSONTyped,
} from './ErrorsInner';
import type { DisplayBrightness } from './DisplayBrightness';
import {
    DisplayBrightnessFromJSON,
    DisplayBrightnessFromJSONTyped,
    DisplayBrightnessToJSON,
    DisplayBrightnessToJSONTyped,
} from './DisplayBrightness';
import type { Weekschedule } from './Weekschedule';
import {
    WeekscheduleFromJSON,
    WeekscheduleFromJSONTyped,
    WeekscheduleToJSON,
    WeekscheduleToJSONTyped,
} from './Weekschedule';

/**
 * 
 * @export
 * @interface Config
 */
export interface Config {
    /**
     * 
     * @type {AmbientOffset}
     * @memberof Config
     */
    ambientOffset?: AmbientOffset;
    /**
     * 
     * @type {BoilerControlMode}
     * @memberof Config
     */
    boilerControlMode?: BoilerControlMode;
    /**
     * 
     * @type {ClimateMode}
     * @memberof Config
     */
    climateMode?: ClimateMode;
    /**
     * 
     * @type {DeviceInfo}
     * @memberof Config
     */
    deviceInfo?: DeviceInfo;
    /**
     * Command the device to reset itself. Use with caution.
     * @type {object}
     * @memberof Config
     */
    deviceReset?: object;
    /**
     * 
     * @type {DhwBoost}
     * @memberof Config
     */
    dhwBoost?: DhwBoost;
    /**
     * 
     * @type {DhwPreferences}
     * @memberof Config
     */
    dhwPreferences?: DhwPreferences;
    /**
     * 
     * @type {DisplayBrightness}
     * @memberof Config
     */
    displayBrightness?: DisplayBrightness;
    /**
     * A list of unresolved errors on the device.
     * @type {Array<ErrorsInner>}
     * @memberof Config
     */
    errors?: Array<ErrorsInner>;
    /**
     * 
     * @type {FilterState}
     * @memberof Config
     */
    filterState?: FilterState;
    /**
     * 
     * @type {FlameState}
     * @memberof Config
     */
    flameState?: FlameState;
    /**
     * 
     * @type {HeatPumpSetup}
     * @memberof Config
     */
    heatPumpSetup?: HeatPumpSetup;
    /**
     * 
     * @type {Legionella}
     * @memberof Config
     */
    legionella?: Legionella;
    /**
     * 
     * @type {PreheatSetpoint}
     * @memberof Config
     */
    preheatSetpoint?: PreheatSetpoint;
    /**
     * 
     * @type {RemoteLogging}
     * @memberof Config
     */
    remoteLogging?: RemoteLogging;
    /**
     * 
     * @type {RoomSetpoint}
     * @memberof Config
     */
    roomSetpoint?: RoomSetpoint;
    /**
     * 
     * @type {ConfigSettings}
     * @memberof Config
     */
    settings?: ConfigSettings;
    /**
     * 
     * @type {SharingPolicy}
     * @memberof Config
     */
    sharingPolicy?: SharingPolicy;
    /**
     * 
     * @type {Ventilation}
     * @memberof Config
     */
    ventilation?: Ventilation;
    /**
     * 
     * @type {Weekschedule}
     * @memberof Config
     */
    weekschedule?: Weekschedule;
    /**
     * 
     * @type {WeekscheduleState}
     * @memberof Config
     */
    weekscheduleState?: WeekscheduleState;
}

/**
 * Check if a given object implements the Config interface.
 */
export function instanceOfConfig(value: object): value is Config {
    return true;
}

export function ConfigFromJSON(json: any): Config {
    return ConfigFromJSONTyped(json, false);
}

export function ConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): Config {
    if (json == null) {
        return json;
    }
    return {
        
        'ambientOffset': json['ambient_offset'] == null ? undefined : AmbientOffsetFromJSON(json['ambient_offset']),
        'boilerControlMode': json['boiler_control_mode'] == null ? undefined : BoilerControlModeFromJSON(json['boiler_control_mode']),
        'climateMode': json['climate_mode'] == null ? undefined : ClimateModeFromJSON(json['climate_mode']),
        'deviceInfo': json['device_info'] == null ? undefined : DeviceInfoFromJSON(json['device_info']),
        'deviceReset': json['device_reset'] == null ? undefined : json['device_reset'],
        'dhwBoost': json['dhw_boost'] == null ? undefined : DhwBoostFromJSON(json['dhw_boost']),
        'dhwPreferences': json['dhw_preferences'] == null ? undefined : DhwPreferencesFromJSON(json['dhw_preferences']),
        'displayBrightness': json['display_brightness'] == null ? undefined : DisplayBrightnessFromJSON(json['display_brightness']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(ErrorsInnerFromJSON)),
        'filterState': json['filter_state'] == null ? undefined : FilterStateFromJSON(json['filter_state']),
        'flameState': json['flame_state'] == null ? undefined : FlameStateFromJSON(json['flame_state']),
        'heatPumpSetup': json['heat_pump_setup'] == null ? undefined : HeatPumpSetupFromJSON(json['heat_pump_setup']),
        'legionella': json['legionella'] == null ? undefined : LegionellaFromJSON(json['legionella']),
        'preheatSetpoint': json['preheat_setpoint'] == null ? undefined : PreheatSetpointFromJSON(json['preheat_setpoint']),
        'remoteLogging': json['remote_logging'] == null ? undefined : RemoteLoggingFromJSON(json['remote_logging']),
        'roomSetpoint': json['room_setpoint'] == null ? undefined : RoomSetpointFromJSON(json['room_setpoint']),
        'settings': json['settings'] == null ? undefined : ConfigSettingsFromJSON(json['settings']),
        'sharingPolicy': json['sharing_policy'] == null ? undefined : SharingPolicyFromJSON(json['sharing_policy']),
        'ventilation': json['ventilation'] == null ? undefined : VentilationFromJSON(json['ventilation']),
        'weekschedule': json['weekschedule'] == null ? undefined : WeekscheduleFromJSON(json['weekschedule']),
        'weekscheduleState': json['weekschedule_state'] == null ? undefined : WeekscheduleStateFromJSON(json['weekschedule_state']),
    };
}

export function ConfigToJSON(json: any): Config {
    return ConfigToJSONTyped(json, false);
}

export function ConfigToJSONTyped(value?: Config | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ambient_offset': AmbientOffsetToJSON(value['ambientOffset']),
        'boiler_control_mode': BoilerControlModeToJSON(value['boilerControlMode']),
        'climate_mode': ClimateModeToJSON(value['climateMode']),
        'device_info': DeviceInfoToJSON(value['deviceInfo']),
        'device_reset': value['deviceReset'],
        'dhw_boost': DhwBoostToJSON(value['dhwBoost']),
        'dhw_preferences': DhwPreferencesToJSON(value['dhwPreferences']),
        'display_brightness': DisplayBrightnessToJSON(value['displayBrightness']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(ErrorsInnerToJSON)),
        'filter_state': FilterStateToJSON(value['filterState']),
        'flame_state': FlameStateToJSON(value['flameState']),
        'heat_pump_setup': HeatPumpSetupToJSON(value['heatPumpSetup']),
        'legionella': LegionellaToJSON(value['legionella']),
        'preheat_setpoint': PreheatSetpointToJSON(value['preheatSetpoint']),
        'remote_logging': RemoteLoggingToJSON(value['remoteLogging']),
        'room_setpoint': RoomSetpointToJSON(value['roomSetpoint']),
        'settings': ConfigSettingsToJSON(value['settings']),
        'sharing_policy': SharingPolicyToJSON(value['sharingPolicy']),
        'ventilation': VentilationToJSON(value['ventilation']),
        'weekschedule': WeekscheduleToJSON(value['weekschedule']),
        'weekschedule_state': WeekscheduleStateToJSON(value['weekscheduleState']),
    };
}

